import React, { Component } from 'react';
import Collapsible from 'react-collapsible';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import api from '../../../axios-local-api';
import Spinner from '../../../components/UI/Spinner/Spinner';
import Box from '../../../hoc/Box/Box';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';
import * as actions from '../../../store/actions/index';
import classes from './RouterPerformance.css';
import { EquipmentTypes } from '../../../shared/common';
class RouterPerformance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      upArrow: false,
      //noRouterData:false,
    };
    this.setEquipmentSelection = this.setEquipmentSelection.bind(this);
  }
  setEquipmentSelection() {
    this.props.onSetSelectedEquipment({
      displayAllEquipment: false,
      type: EquipmentTypes.Router,
      routerId: this.props.realWan.id,
      mac: this.props.realWan.mac,
      nickname: this.props.realWan.defaultName,
      didClick: false,
    });
  }

  openHandler() {
    this.setState({
      upArrow: true,
    });
  }
  closeHandler() {
    this.setState({
      upArrow: false,
    });
  }

  getFreqBand = (freqBand) => {
    if (freqBand && (freqBand.includes('5G') || freqBand.includes('5g'))) {
      return '5GHz';
    } else if (
      freqBand &&
      (freqBand.includes('2.4G') || freqBand.includes('2.4g'))
    ) {
      return '2.4GHz';
    }
    return '';
  };
  getTableRowContent = (data, type, parentPod, deviceType) => {
    // console.log("data, type, parentPod,deviceType:", data, type, parentPod,deviceType);
    const colorCode = {
      connected: 'green',
      excellent: 'green',
      disconnected: 'red',
      poor: 'red',
      good: 'green',
      fair: 'red',
      calculating: 'orange',
    };
    let connectedTo = 'N/A';

    let connectedDevice = 'N/A';
    let deviceName;
    let model;
    let signalStatus = data.health ? data.health.status : 'disconnected';
    if (type === EquipmentTypes.Router) {
      connectedTo = data.health ? 'Modem' : connectedTo;
      if (signalStatus === 'disconnected') {
        deviceName = 'Router';
      } else {
        deviceName = data.health ? 'Router' : data.defaultName;
      }

      if (data.connectionState === 'disconnected') {
        connectedDevice = 'N/A';
      } else {
        connectedDevice =
          data.backhaulType === 'unknown'
            ? 'N/A'
            : data.backhaulType || connectedDevice;
      }
      model = this.props.wan.realWan.model;
      signalStatus =
        data.backhaulType === 'ethernet' || connectedTo === 'Modem'
          ? 'Connected'
          : signalStatus;
      if (this.props.wan && this.props.wan.checkingWan) {
        signalStatus = 'disconnected';
      }
    }
    let colorStyleCode = '#6F777E';
    let colorClassname;

    if (signalStatus === 'disconnected') {
      colorStyleCode = colorCode.disconnected;
      colorClassname = classes.disconnected;
    } else {
      colorStyleCode = data.health
        ? colorCode[data.health.status]
        : colorCode.disconnected;
      colorClassname = data.health
        ? classes[data.health.status]
        : classes.disconnected;
    }

    const colorDot = (
      <div
        className={classes.colorDot}
        style={{ display: 'flex', alignItems: 'center' }}
      >
        <div className={colorClassname}></div>
        <div style={{ width: '10px' }} />
        <div
          id="signal"
          className={classes.statusName}
          style={{ color: colorStyleCode }}
        >
          {signalStatus}
        </div>
      </div>
    );

    if (deviceType === 'Mobile') {
      return (
        <Box>
          <tr>
            <td
              style={{
                padding: '16px',
                borderRight: 'none',
                borderLeft: 'none',
              }}
            >
              <Link
                to={{
                  pathname: '/overview',
                  query: {
                    wifiServiceCheck: true,
                    type: 'router',
                    itemId: this.props.realWan.id,
                  },
                }}
                style={{ color: '#0073d1', textDecoration: 'none' }}
                onClick={this.setEquipmentSelection}
              >
                {deviceName}
              </Link>
            </td>{' '}
          </tr>
        </Box>
      );
    } else {
      let connectedDeviceWithColor;
      if (connectedDevice.includes('2.4GHz')) {
        connectedDeviceWithColor = (
          <td
            className={classes.connection_column}
            style={{
              padding: '10px',
              borderRight: 'none',
              borderLeft: 'none',
              color: 'red',
            }}
          >
            {connectedDevice}
          </td>
        );
      } else {
        if (connectedDevice === 'ethernet') {
          connectedDevice = 'Ethernet';
        }
        connectedDeviceWithColor = (
          <td
            id="EquipmentConnection"
            className={classes.connection_column}
            style={{ padding: '10px', borderRight: 'none', borderLeft: 'none' }}
          >
            {connectedDevice}
          </td>
        );
      }
      //let changeGroupObject = {'deviceMac': this.props.originalDevice.mac, 'showMoveDeviceModal':true};
      return (
        <tr className={classes.trTag}>
          <td
            id="RouterEquipmentName"
            style={{ padding: '16px', borderRight: 'none', borderLeft: 'none' }}
            className={[classes.showDesktop, classes.showDesktop1].join(' ')}
          >
            <Link
              to={{
                pathname: '/overview',
                query: {
                  wifiServiceCheck: true,
                  type: 'router',
                  itemId: this.props.realWan.id,
                },
              }}
              style={{ color: '#0073d1', textDecoration: 'none' }}
              onClick={this.setEquipmentSelection}
            >
              {deviceName}
            </Link>
          </td>

          <td
            id="RouterEquipmentSignal"
            style={{ padding: '16px', borderRight: 'none', borderLeft: 'none' }}
          >
            {colorDot}
          </td>
          {connectedDeviceWithColor}

          <td
            id="RouterEquipmentConnectedTo"
            style={{ padding: '10px', borderRight: 'none', borderLeft: 'none' }}
          >
            {connectedTo}
          </td>
          <td
            id="RouterEquipmentModel"
            style={{ padding: '10px', borderRight: 'none', borderLeft: 'none' }}
          >
            {model}
          </td>
        </tr>
      );
    }
  };

  getEquipmentStatusRows = (deviceType = '') => {
    const realWan = this.props.realWan;
    const claimedPods = this.props.claimedPods;
    const unclaimedPods = this.props.unclaimedPods;
    //console.log(this.props, 'unclaimed pods')
    const equipmentStatusContent = [];
    if (!realWan) {
      return undefined;
    }
    if (realWan && typeof realWan === 'object' && Object.keys(realWan).length) {
      // if(realWan.connectionState === "disconnected" || realWan.connectionState === "unavailable" ) {
      //   this.setState({
      //     noRouterData : true
      //   });
      equipmentStatusContent.push(
        this.getTableRowContent(realWan, 'router', '', deviceType)
      );
      // }
    }

    return equipmentStatusContent;
  };
  render() {
    let arrow = <MdKeyboardArrowDown color={'gray'} size={'30px'} />;
    if (this.state.upArrow || this.props.wifiServiceRouterFailedCount > 0) {
      arrow = <MdKeyboardArrowUp color={'gray'} size={'30px'} />;
    } else {
      arrow = <MdKeyboardArrowDown color={'gray'} size={'30px'} />;
    }

    let infoRow;
    let equipNameData;
    if (this.props.loading || !this.props.loaded) {
      infoRow = <Spinner />;
    } else {
      infoRow = (
        <div>
          <div className={classes.showMobile} style={{ float: 'left' }}>
            <table className={classes.devTable} cellPadding="0" cellSpacing="0">
              <thead>
                <tr>
                  <th
                    style={{
                      borderLeft: 'none',
                      borderRight: 'none',
                      textAlign: 'left',
                      padding: '16px',
                      color: 'grey',
                    }}
                  >
                    Equip. Name
                  </th>
                </tr>
              </thead>
              <tbody>{this.getEquipmentStatusRows('Mobile')}</tbody>
            </table>
          </div>

          <div className={classes.tablewrapper}>
            <table className={classes.devTable} cellPadding="0" cellSpacing="0">
              <thead>
                <tr className={classes.trTag}>
                  <th
                    className={classes.showDesktop}
                    style={{
                      borderLeft: 'none',
                      borderRight: 'none',
                      textAlign: 'left',
                      padding: '16px',
                      color: 'grey',
                    }}
                  >
                    Equip. Name
                  </th>

                  <th
                    style={{
                      borderLeft: 'none',
                      borderRight: 'none',
                      textAlign: 'left',
                      padding: '16px',
                      color: 'grey',
                    }}
                  >
                    Signal
                  </th>
                  <th
                    style={{
                      borderLeft: 'none',
                      borderRight: 'none',
                      textAlign: 'left',
                      padding: '16px',
                      color: 'grey',
                    }}
                  >
                    Connection
                  </th>
                  <th
                    style={{
                      borderLeft: 'none',
                      borderRight: 'none',
                      textAlign: 'left',
                      padding: '10px',
                      color: 'grey',
                    }}
                  >
                    Connected To
                  </th>
                  <th
                    style={{
                      borderLeft: 'none',
                      borderRight: 'none',
                      textAlign: 'left',
                      padding: '10px',
                      color: 'grey',
                    }}
                  >
                    Model #
                  </th>
                </tr>
              </thead>
              <tbody>{this.getEquipmentStatusRows('Desktop')}</tbody>
            </table>
          </div>
        </div>
      );
    }
    // if(this.state.noRouterData){
    //   infoRow = '';
    // }
    let openCollapsible =
      this.props.wifiServiceRouterFailedCount > 0 ? true : false;

    return (
      <Box>
        <div className={classes.RouterPerformanceComponent}>
          <Collapsible
            open={openCollapsible}
            transitionTime={100}
            onOpening={() => {
              this.openHandler();
            }}
            onClosing={() => {
              this.closeHandler();
            }}
            trigger={
              <Box>
                <div className={classes.RouterPerformanceComponentCollapse}>
                  <div className={classes.TitleArea}>
                    <h3 style={{ paddingRight: 20 }}>Router Performance</h3>

                    <button
                      id="RouterPerformanceArrow"
                      className={classes.OpenCloseButton}
                      style={{ float: 'right' }}
                      aria-label="open arrow"
                    >
                      {arrow}
                    </button>
                  </div>

                  <div className={classes.HorizontalSeparator} />
                </div>
              </Box>
            }
          >
            {infoRow}
          </Collapsible>
        </div>
      </Box>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    loading: state.equipment.loading,
    loaded: state.equipment.loaded,
    realWan: state.wan.realWan,
    equipment: state.equipment,
    claimedPods:
      state.equipment && state.equipment.realEquipment
        ? state.equipment.realEquipment.claimedPods
        : [],
    unclaimedPods:
      state.equipment && state.equipment.realEquipment
        ? state.equipment.realEquipment.unclaimedPods
        : [],
    wan: state.wan,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onInitWan: () => dispatch(actions.initWan()),
    onInitEquipment: () => {
      dispatch(actions.initEquipment());
    },
    refreshDevices: () => dispatch(actions.refreshDevices()),
    onSetSelectedEquipment: (equipment) => {
      dispatch(actions.setSelectedEquipment(equipment));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(RouterPerformance, api));
